import styles from './empty-list-wrapper.module.css';
import clsx from 'clsx';
import { useMediaQuery } from '@/hooks/use-media-query';

interface EmptyListWrapperProps {
  title: string;
  subtitle?: string;
  icon?: {
    src: string;
    alt: string;
  };
}

export function EmptyListWrapper({ title, subtitle, icon }: EmptyListWrapperProps) {
  const isMobile = useMediaQuery('--screen-md');

  return (
    <div className={styles.container}>
      {icon && <img src={icon.src} alt={icon.alt} className={styles.icon} />}
      <div className={styles.text}>
        <p className={clsx(styles.title, !isMobile && 'body-1')}>{title}</p>
        {subtitle && <p className={clsx(isMobile && 'body-3')}>{subtitle}</p>}
      </div>
    </div>
  );
}
